const DEVICE_ID_KEY = 'nailtoctoc_admin_device_id';

// Device ID 가져오기 없으면 생성
export const getOrCreateDeviceId = (): string => {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
    console.log('🆕 새 Device ID 생성');
  } else {
    console.log('✅ 기존 Device ID 사용');
  }

  return deviceId;
};

// Device ID 삭제
export const clearDeviceId = (): void => {
  localStorage.removeItem(DEVICE_ID_KEY);
  console.log('🗑️ Device ID 삭제됨');
};